<div class="search-form">
  <sha-create-vehicle-with-associate [vehicle]="vehicle" [associate]="associate" [address]="address"
    [vehicleDropdowns$]="serviceLaneDropdownFacade.vehicleDropdowns$"
    [associateDropdowns$]="serviceLaneDropdownFacade.associateDropdowns$"
    [addressDropdowns$]="serviceLaneDropdownFacade.addressDropdowns$" (createEmitted)="createVehicle($event)">
  </sha-create-vehicle-with-associate>
</div> 